import Model from "@/lib/model/model";

export class OptionMap {}

export class EncodeConfig extends Model {
  encodeTypeConnectCode = 0;
  encodeTypeBaseInfo = 0;
  encodeTypeOtherInfo = 0;
  encodeCandidateInfo = 0;
}

export class ReportShowConfigV5Item extends Model {
  name = ""; //模块名称
  aliasName = "";
  enName = "";
  versionId = 0; //选择的版本id
  isHidden = false; //是否隐藏
  sort = -1; //排序
  optionMap = new OptionMap(); //配置项
}

export class ReportConfig extends Model {
  encodeConfig = new EncodeConfig();
  reportShowConfigV5: ReportShowConfigV5Item[] = [];
  reportShowConfigV6: ReportShowConfigV5Item[] = [];

  public objectArrayClasses() {
    return {
      reportShowConfigV5: ReportShowConfigV5Item,
      reportShowConfigV6: ReportShowConfigV5Item
    };
  }
}
